import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { storageService } from '../storage.service';

@Component({
    selector: 'app-select-lob',
    imports: [CommonModule, FormsModule],
    templateUrl: './select-lob.component.html',
    styleUrl: './select-lob.component.scss'
})
export class SelectLobComponent implements OnInit {
    lobs: string[] = [];
    selectedLob: string = '';
    loginData: any;

    constructor(
        private router: Router,
        private _storage: storageService
    ) {
        const nav = this.router.getCurrentNavigation();
        this.loginData = nav?.extras?.state?.['loginData'];
    }

    ngOnInit(): void {
        this.lobs = this.loginData?.lobs || JSON.parse(sessionStorage.getItem('lobs') || '[]');
    }

    onEnter(): void {
        if (!this.selectedLob) return;
        sessionStorage.setItem('selectedLob', JSON.stringify(this.selectedLob));
        this.handleSingleLobLogin(this.loginData)
    }
    handleSingleLobLogin(x: any) {
        this._storage.setStorage(x);
    }
}
